import Vue from 'vue';
import Vuex from 'vuex';

import remoteService from '@/services/remote-service';
import PageUtils from '@/utils/page-utils';

import competition from './competition';
import sections from './sections';
import solution from './solution';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    solution,
    sections,
    competition
  },
  state: {
    stats: {
      star: 0
    },
    lastPageIndex: null,
    nextPage: null,
    isStudioEventTimeFinished: false,
    isStudioBlocked: false
  },
  getters: {
    totalStars(state) {
      return state.stats.star;
    },
    lastPageIndex(state) {
      return state.lastPageIndex;
    },
    lastSolution(state) {
      return state.solution.lastSolution;
    },
    nextPageSolution(state) {
      return state.solution.nextPageSolution;
    },
    totalSolutionCount(state) {
      return state.solution.solutionCount;
    },
    sectionIndex(state) {
      return state.solution.sectionIndex || 1;
    },
    distributorCompanyCode(state) {
      return (
        state.CodementumUser.distributorCompany &&
        state.CodementumUser.distributorCompany.code
      );
    },
    isPrivateDistributor(state, getters) {
      return ['CODINGOLYMPIADORG', 'CODEMINATOR', 'GLOW'].includes(
        getters.distributorCompanyCode
      );
    },
    isUserFree(_, getters) {
      return getters['CodementumUser/isFree'];
    },
    isPurchaseUser(_, getters) {
      return !getters.isStudioEvent && getters.isUserFree;
    },
    isStudioEvent() {
      return PageUtils.isStudioEvent();
    },
    isStudioEventTimeFinished(state) {
      return state.isStudioEventTimeFinished;
    },
    isStudioBlocked(state) {
      return state.isStudioBlocked;
    }
  },
  mutations: {
    fillStats(state, stats) {
      state.stats = { ...state.stats, ...stats };
    },
    setStars(state, value) {
      state.stats.star = value;
    },
    incrementStarsBy(state, inc) {
      state.stats.star += inc;
    },

    setLastPageIndex(state, index = null) {
      state.lastPageIndex = index;
    },
    setNextPage(state, page = null) {
      state.nextPage = page;
    },
    setIsStudioEventTimeFinished(state) {
      state.isStudioEventTimeFinished = true;
    },
    setIsStudioBlocked(state, blocked = true) {
      state.isStudioBlocked = blocked;
    }
  },
  actions: {
    getPrincipalStats({ commit }) {
      remoteService.loadPrincipalStats().then(({ data }) => {
        commit('fillStats', data);
      });
    },

    getLastPage({ commit }, uuid) {
      remoteService.getProducts(uuid).then((index) => {
        commit('setLastPageIndex', Number.isSafeInteger(index) ? index : null);
      });
    }
  }
});
